import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Hours from '@/components/Hours'
import MapPanel from '@/components/MapPanel'
import Newsletter from '@/components/Newsletter'
import Booking from '@/components/Booking'

Vue.use(Router)

export default new Router({
	mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          name: 'Hours',
          path: 'hours',
          components: {
            overlay: Hours
          },
          meta: {
            overlay: true
          }
        },
        {
          name: 'Location',
          path: 'location',
          components: {
            overlay: MapPanel
          },
          meta: {
            overlay: true
          }
        },
        {
          name: 'Newsletter',
          path: 'newsletter',
          components: {
            overlay: Newsletter
          },
          meta: {
            overlay: true
          }
        }
      ]
    },
    {
      path: '/booking',
      name: 'Booking',
      component: Booking
    }
  ]
})
